__turbopack_context__.v({
  "divider": "snapshotDivider-module-scss-module__t75OrW__divider",
  "dividerLine": "snapshotDivider-module-scss-module__t75OrW__dividerLine",
});
